import React from "react";
import ErrorReportModal from './ErrorReportModal';
import { Button } from "react-bootstrap";
import errorImage from "../../error.png";

export default class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null, info: null, showModal: false };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("React error caught in ErrorBoundary:", error, info);
        this.setState({ error, info });
    }

    openReport = () => this.setState({ showModal: true });
    closeReport = () => this.setState({ showModal: false });

    render() {
        if (this.state.hasError) {
            return (
                <div className="splash">
                    <div className="d-flex h-100 gap-3 flex-column align-items-center justify-content-center">
                        <img src={errorImage} alt="errorImage" className="img-fluid" width={500}/>
                        <h1 className="text-light">Leider ist ein Fehler aufgetreten</h1>
                        <p>
                            <b>
                                Sie können uns eine Fehlerbeschreibung hinterlassen 
                                - wir versuchen unsere Dienste schnellstmöglich zu 
                                verbessern
                            </b>
                        </p>
                        <Button onClick={() => this.openReport()} variant="danger" style={{width: 200}}>Fehler melden</Button>
                        <Button onClick={() => window.location.reload()} variant="warning" style={{width: 200}}>Erneut versuchen</Button>
                        <Button onClick={() => window.location.replace("/")} variant="secondary" style={{width: 200}}>Zur Startseite</Button>
                    </div>
                    {this.state.showModal && (
                        <ErrorReportModal
                            error={this.state.error}
                            info={this.state.info}
                            show={this.state.showModal}
                            onClose={this.closeReport}
                        />
                    )}
                </div>
            );
        }
        return this.props.children;
    }
}